import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import shouldForwardProp from "@styled-system/should-forward-prop";
import React from "react";
import { compose, space, SpaceProps } from "styled-system";

import { theme } from "~/components/styles/theme";

type HeaderProps = SpaceProps;

type Props = HeaderProps & {
  action?: React.ReactNode;
  as?: React.ElementType;
  attached?: boolean;
  children: React.ReactNode;
};

export const StyledHeader = styled("header", {
  shouldForwardProp,
})<Props & HeaderProps>(
  () =>
    css({
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      [`@media ${theme.mediaQueries.tablet}`]: {
        fontSize: theme.fontSizes.m,
        flexWrap: "wrap",
      },
    }),
  ({ theme, attached }) =>
    attached &&
    css({
      borderBottom: theme.borders.default,
      justifyContent: "center",
      padding: theme.space.l,
    }),
  compose(space),
);

const Nav = styled("div")(() =>
  css({
    position: "absolute",
    left: 0,
  }),
);

const Title = styled("div")(() =>
  css({
    display: "flex",
    alignItems: "center",
  }),
);

export const Header: React.VFC<Props> = (props) => {
  const { action, children, ...headerProps } = props;

  return (
    <StyledHeader {...headerProps}>
      <Title>{children}</Title>
      {action && <Nav>{action}</Nav>}
    </StyledHeader>
  );
};
